// extracted by mini-css-extract-plugin
module.exports =  {"colorSwatch":"jut__ColorSwatch__colorSwatch","box":"jut__ColorSwatch__box","title":"jut__ColorSwatch__title","color":"jut__ColorSwatch__color"};